import { Accordion } from 'flowbite-react';
const FlutterFAQ: React.FC = () => {
    return (
        <>
            <Accordion>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What is Flutter App Development?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            Flutter is an open-source
                            <a href="mobile-app-development" className="font-semibold underline pl-1" target="_self">
                                Mobile app development
                            </a>{' '}
                            framework from Google that enables businesses to create high-quality cross-platform mobile
                            applications using a single codebase. It allows developers to build fast, native-like applications for
                            both Android and iOS platforms. For more details on how Flutter compares to other development
                            frameworks, check out our mobile app development services{' '}
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        {' '}
                        What is the cost of developing a Flutter Application?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            The cost of Flutter app development depends on several factors, including the app’s complexity,
                            features, and third-party integrations. Contact us for a detailed estimate based on your specific
                            project needs.{' '}
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        {' '}
                        Can you migrate my existing app into Flutter?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            Yes, we offer Flutter app migration services to help businesses transition their existing applications
                            to Flutter seamlessly. Our developers ensure that the migration process is smooth and optimized for
                            performance.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        Is Flutter good for MVP development?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            Yes, Flutter is an excellent choice for MVP {`(Minimum Viable Product)`} development. Its rapid
                            development capabilities, combined with the ability to build cross-platform apps, make it ideal for
                            businesses looking to quickly validate their ideas in the market.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What are the advantages of Flutter app development?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            Flutter app development offers numerous advantages, such as faster development cycles, cost savings,
                            and a single codebase for both Android and iOS platforms. Additionally, {`Flutter’s`} support for
                            <a href="ui-ux-design" className="font-semibold underline" target="_self">
                                custom UI/UX design
                            </a>
                            and integration with other frameworks makes it a top choice for businesses. Explore more benefits on
                            our cross-platform app development page.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        {' '}
                        What other services does Moweb offer besides Flutter app development?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary">
                            Moweb offers a wide range of services, including web development, mobile app development{' '}
                            {`(using technologies like React Native and Kotlin)`}, custom software development, UI/UX design, and
                            more. You can explore our other services on our website or contact us for a consultation.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
            </Accordion>
        </>
    );
};

export default FlutterFAQ;
